
/**
 * 
 * 
 * Stuff:
 * 
 * - man kan åbne dialogen fra en menu ved at dispatche eventet som dialog bruger.
 * 
 * - hvordan ville hubspot login se ud med det nye system.
 * 
 * - kan man få det til at poppe op automatisk.
 * 
 * - kan man skifte layout på login undervejs. f.eks hvis man vil have sådan nogels små nogle der kommer på et hotspot ..
 * 
 * 
 * -  skal eventet show-login-dialogue bare være request-login
 * 
 * 
 *  - hvoedan finder man ud af man er logget ind til at starte med, måske bare et kald til auth.user().. 
 * 
 * 
 * - skal auth send funktioner til at gemme bruger data ind i strategierne og definerer et fast api på user data ?
 */










Vue.component("TkLogin", {

    props: ["redirectRoute"],

    data () {
        const options = {
            states: {
                default: "default",
                authenticating: "authenticating",
                error_incorrect_credentials: "error_incorrect_credentials",
                login_success: "login_success",
                redirecting: "redirecting",
                error_unauthorized: "error_unauthorized"                
            },
            messages: {
                default: "Sign In",
                authenticating: "Authenticating",
                error_incorrect_credentials: "Invalid Credentials",
                login_success: "Logged in",
                redirecting: "Redirecting",
                error_unauthorized: "Unauthorized"
            },
            disableInputs: false,
            stateClasses: [],
            username: "",
            password: ""
        }
        options.state = options.states.default;
        options.message = options.messages.default;
        return options;
    },

    template: `
        <div class="login-wrap" :class="stateClasses">
        <div class="iconContainer">
            <transition 
            appear
            name="custom-classes-transition"
            appear-to-class="animated bounce" 
            appear-active-class="animated bounce"
            enter-active-class="animated fadeInRight transition-duration-350"
            leave-active-class="animated fadeOutLeft transition-duration-350">
                <div class="icon default" v-if="state === 'default'" key="default">
                    <i class="default login-icon-user"></i>
                </div>
                <div class="icon authenticating" v-if="state === 'authenticating'" key="authenticating">
                    <i class="authenticating login-icon-key"></i>
                    <div class="loader"></div>
                </div>
                <div class="icon error_incorrect_credentials" v-if="state === 'error_incorrect_credentials'" key="error_incorrect_credentials">
                    <i class="error login-icon-cancel-2"></i>
                </div>
                <div class="icon login_success" v-if="state === 'login_success'" key="login_success">
                    <i class="success login-icon-ok-1"></i>
                </div>
                <div class="icon redirecting" v-if="state === 'redirecting'" key="redirecting">
                    <i class="redirect login-icon-level-up"></i>
                    <div class="loader"></div>
                </div>
                <div class="icon error_unauthorized" v-if="state === 'error_unauthorized'" key="error_unauthorized">
                    <i class="error login-icon-cancel-2"></i>
                </div>
            </transition>
        </div>
        <h3 class="text-center mb-4">{{message}}</h3>
        <form action="#" class="login-form" @submit.prevent="submit" :disabled="disableInputs">
            <div class="form-group">
                <input type="text" class="form-control rounded-left" placeholder="Email" required="" v-model="username">
            </div>
            <div class="form-group d-flex">
                <input type="password" class="form-control rounded-left" placeholder="Password" required="" v-model="password">
            </div>
            <div class="form-group">
                <button type="submit" class="form-control btn btn-primary rounded">Login</button>
            </div>
            <slot></slot>
        </form>
    </div>
    `,


    mounted () {
        this.events = {
            "authorization-failed": () => {
                this.setState(this.states.error_unauthorized);
            },
            "authorization-success": () => {
                this.$emit("close")
            }
        }
        app.radio.$on("authorization-failed", this.events["authorization-failed"]);
        app.radio.$on("authorization-success", this.events["authorization-success"]);
    },
    destroyed () {
        app.radio.$off("authorization-failed", this.events["authorization-failed"]);
        app.radio.$off("authorization-success", this.events["authorization-success"]);
    },
    methods: {

        async submit() {
            console.log("Submit clicked", this.username, this.password)

            const username = this.username;
            const password = this.password;

            await this.delayedSetState(this.states.authenticating, 100);

            try {

                await app.authentication.login({ username, password });
                await this.delayedSetState(this.states.login_success, 1000);
                this.onSuccessfulLogin()
            }
            catch (e) {
                await this.delayedSetState(this.states.error_incorrect_credentials, 1000);
            }

        },

       async onSuccessfulLogin () {
            if(this.redirectRoute && this.redirectRoute !== "") {
                await this.delayedSetState(this.states.redirecting)
                await this.delayedPromise(() => {
                    this.$router.push(this.redirectRoute);
                }, 1000);
            }
            else {
                await this.delayedPromise(() => {
                this.$emit("close")
                }, 1000);
            }
        },


        setState(state) {

            this.state = state;
            this.message = this.messages[this.state]

            switch (state) {
                case this.states.default:
                    this.disableInputs = false;
                    this.stateClasses = [];
                    this.password = "";
                break;
                case this.states.authenticating:
                    this.disableInputs = true;
                    this.stateClasses = [];
                break;
                case this.states.error_unauthorized:
                case this.states.error_incorrect_credentials: 
                    setTimeout(() => {
                        this.stateClasses = ["animated shake"]
                    }, 200)
                    setTimeout(() => {
                        this.setState(this.states.default)
                    }, 1500)
                break;
            }
        },


        async delayedPromise(cb, delay = 1000) {
            return new Promise(resolve => {
             
                setTimeout(() => {
                    cb();
                    resolve();
                }, delay)
            })
        },

        async delayedSetState(state, delay = 1000) {
            return this.delayedPromise(() => { this.setState(state) }, delay)
        }
      
    }

})